import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const SellerRegisterApi = createAsyncThunk(
  "sellerRegisterData/sellerRegister",
  async (data, thunkAPI) => {
    console.log("Registering seller with data:", data);
    try {
      const response = await axios.post(endPoint.SellerRegister,
        data
      );
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const SellerRegisterSlice = createSlice({
  name: "SellerRegisterData",
  initialState: {
    SellerRegisterData: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SellerRegisterApi.fulfilled, (state, action) => {
        state.SellerRegisterData = action.payload;
      })
      .addCase(SellerRegisterApi.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default SellerRegisterSlice.reducer;
